export default {
  patreon: 'https://www.patreon.com/runelite',
  twitter: 'https://twitter.com/RuneLiteClient',
  github: 'https://github.com/runelite',
  contribute: 'https://github.com/runelite/runelite/wiki/Developer-Guide'
}
